import type { UploadResponse } from '@/lib/api/models/common'
import { upload } from '@/lib/api/services/common'
import { resolveRemoteDisplayUrl } from '@/lib/image-cache'

import type { GuideRef } from '../types'

export async function uploadGuideRefFile(file: File): Promise<GuideRef> {
  const format = file.type.split('/')[1] || 'jpeg'
  const response: UploadResponse = await upload({
    file,
    format,
    location: 'main'
  })

  return guideRefFromUploadResponse(response, file.name)
}

export function guideRefFromUploadResponse(
  response: UploadResponse,
  name?: string
): GuideRef {
  const displayUrl =
    resolveRemoteDisplayUrl({ res: response }) || response.showImageUrl || response.imageUrl

  return {
    url: displayUrl,
    name,
    status: 'success',
    imageUrl: response.imageUrl,
    imageUrlV1: response.imageUrlV1,
    thumbnailUrl: response.thumbnailUrl,
    thumbnailUrlV1: response.thumbnailUrlV1,
    showImageUrl: response.showImageUrl
  }
}
